import React from 'react'

import MenuSection from '../MenuSection'
import UserSearch from '../UserSearch'

import { LEAD_OPTIONS, LEADS_FOR_USER } from '../../helpers/parse'
import { useTaskFilters } from '@SonarCX/providers/TaskFiltersProvider'
import { useEnvironment } from '@SonarCX/providers/EnvironmentProvider'

type LeadFilterProps = {
  checkFilters?: boolean
  menuMode?: boolean
  closeModal?: () => void
}

const LeadFilter: React.FC<LeadFilterProps> = props => {
  const { state, handleChange } = useTaskFilters()
  const { user } = useEnvironment()

  return (
    <MenuSection
      title='Task Leads'
      options={LEAD_OPTIONS}
      value={state.leadValue}
      setValue={handleChange('leadValue')}
      unassignedOpt='All Task Leads'
      {...props}
    >
      {state.leadValue === LEADS_FOR_USER && (
        <UserSearch
          userID={user?.id}
          value={state.leadID}
          setValue={handleChange('leadID')}
          startOpen
        />
      )}
    </MenuSection>
  )
}

export default LeadFilter
